


















































































































































import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  inject,
  computed,
  onBeforeMount,
} from '@vue/composition-api'
import EditVolume from './components/Volume/EditVolume.vue'
import CreateVolume from './components/Volume/CreateVolume.vue'
import { Volume, Textbook } from '@/shared/types'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
import { pagination } from '@/shared/utils'

import {
  CREATE_VOLUME,
  EDIT_VOLUME,
  DELETE_VOLUME,
} from '@/shared/user/permissions'
export default defineComponent({
  name: 'VolumeOverview',
  components: {
    CreateVolume,
    EditVolume,
  },
  setup(props, { root }) {
    const data = reactive({
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Kennung',
          value: 'key',
        },
        {
          text: 'Aktionen',
          value: 'actions',
        },
      ],
      search: undefined,
    })

    const editDialogOpen = ref(false)
    const selectedVolume = ref(null)
    const { getters, actions } = useTextbookStore()
    const { hasPermissionTo } = useUserStore().getters
    const { textbooks, activeTextbook, loading } = getters
    const { deleteVolume, updateVolume, loadTextbooks } = actions
    const volumes = computed(() =>
      activeTextbook.value ? activeTextbook.value.volumes : []
    )
    const showCreateVolumeDialog = ref(false)
    const $alert = inject(alertSymbol) as Function
    const showCreateVolumeDialogHandler = () => {
      showCreateVolumeDialog.value = true
    }

    const editItem = (item: Volume) => {
      selectedVolume.value = item
      editDialogOpen.value = true
    }
    const copyItem = (item: Volume) => {
      const input = document.createElement('input')
      input.value = item.link
      input.select();
      input.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(input.value);
      $alert({
        type: 'success',
        text: root.$t('volume.copied', {
          volumeName: item.name,
          link: item.link
        }),
      })
    }
    const deleteItem = async (item: Volume) => {
      await $alert({
        type: 'confirm',
        text: root.$t('volume.confirmDelete', {
          volumeName: item.name,
        }),
      })
      await deleteVolume(activeTextbook.value.id, item.id)
      $alert({
        type: 'success',
        text: root.$t('volume.deleted', {
          volumeName: item.name,
        }),
      })
    }

    onBeforeMount(loadTextbooks)

    const onVolumeCreated = (newVolume: Volume) => {
      const textbook = textbooks.value
        .filter((el: Textbook) => el.id === activeTextbook.value.id)
        .pop()
      textbook.volumes.push(newVolume)
      showCreateVolumeDialog.value = false
    }

    const onVolumeEdited = (newVolume: Volume) => {
      updateVolume(newVolume)
      selectedVolume.value = null
      editDialogOpen.value = false
    }

    return {
      ...toRefs(data),
      editItem,
      copyItem,
      volumes,
      editDialogOpen,
      selectedVolume,
      onVolumeEdited,
      showCreateVolumeDialog,
      showCreateVolumeDialogHandler,
      onVolumeCreated,
      textbooks,
      activeTextbook,
      deleteItem,
      loading,
      hasPermissionTo,
      CREATE_VOLUME,
      EDIT_VOLUME,
      DELETE_VOLUME,
      pagination,
    }
  },
})
